export default "__VITE_ASSET__79e30a2d__"